module.exports = __webpack_public_path__ + "static/img/qq-fill.b852f057.svg";